const TOUR_EVENT = "yts:tour-start";
const TOUR_MENU_EVENT = "yts:tour-menu";

/** Opens the guided site tour from anywhere (menu, footer, a page CTA). */
export const startTour = () => window.dispatchEvent(new Event(TOUR_EVENT));

/** Drives the actual hamburger drawer during the guided walkthrough. */
export const setTourMenuOpen = (open) => {
  window.dispatchEvent(new CustomEvent(TOUR_MENU_EVENT, { detail: { open } }));
};

/** Lets the header respond to the same interaction as a visitor's menu button. */
export const onTourMenuChange = (handler) => {
  const listener = (event) => handler(Boolean(event.detail?.open));
  window.addEventListener(TOUR_MENU_EVENT, listener);
  return () => window.removeEventListener(TOUR_MENU_EVENT, listener);
};

/** Subscribes the tour overlay to those requests; returns the unsubscribe. */
export const onTourStart = (handler) => {
  window.addEventListener(TOUR_EVENT, handler);
  return () => window.removeEventListener(TOUR_EVENT, handler);
};